// P2b tanda 1 — validaciones de cliente del formulario de producto.
// Cada regla refleja un punto de la guía (guia-carga-productos-shopping-hunters.md,
// Parte B). Funciones puras: devuelven { ok, error }. El formulario las usa para
// marcar campos; el panel de estado (tanda 4) reusará las mismas reglas.

const norm = (v) => String(v == null ? '' : v).trim();

// Mayúsculas sostenidas: tiene letras, ninguna minúscula, y al menos 3 letras
// (una sigla corta como "XS" o "M" no es "sostenida").
function isAllCaps(value) {
  const s = norm(value);
  const letters = s.replace(/[^A-Za-zÀ-ÿ]/g, '');
  if (letters.length < 3) return false;
  return letters === letters.toUpperCase() && letters !== letters.toLowerCase();
}

// El nombre no lleva contenido (50 ml / 50g) ni la unidad suelta.
function nameHasContent(value) {
  const s = norm(value);
  return /\b\d+\s*(ml|g|gr|oz|kg|l)\b/i.test(s) || /\bml\b/i.test(s);
}

function validateName(value) {
  const s = norm(value);
  if (!s) return { ok: false, error: 'El nombre es obligatorio.' };
  if (isAllCaps(s)) return { ok: false, error: 'No uses mayúsculas sostenidas; escribe con mayúscula inicial.' };
  if (nameHasContent(s)) return { ok: false, error: 'El contenido (ml/g) y el tono no van en el nombre.' };
  return { ok: true, error: null };
}

function validateShortDescription(value) {
  const s = norm(value);
  if (!s) return { ok: false, error: 'La descripción corta es obligatoria.' };
  if (s.length > 150) return { ok: false, error: `Máximo 150 caracteres (vas en ${s.length}).` };
  return { ok: true, error: null };
}

function validateSku(value) {
  const s = norm(value);
  if (!s) return { ok: false, error: 'El SKU es obligatorio.' };
  if (!/^[A-Z0-9-]+$/.test(s)) return { ok: false, error: 'Solo mayúsculas, números y guiones. Sin espacios ni tildes.' };
  return { ok: true, error: null };
}

function validatePrice(value) {
  const s = norm(value);
  if (!s) return { ok: false, error: 'El precio es obligatorio.' };
  if (!/^\d+$/.test(s)) return { ok: false, error: 'En pesos, sin puntos ni símbolos (ej. 155000).' };
  if (Number(s) <= 0) return { ok: false, error: 'El precio debe ser mayor que 0.' };
  return { ok: true, error: null };
}

// Precio rebajado: opcional; si existe, válido y menor al normal.
function validateSalePrice(value, regular) {
  const s = norm(value);
  if (!s) return { ok: true, error: null };
  if (!/^\d+$/.test(s)) return { ok: false, error: 'En pesos, sin puntos ni símbolos.' };
  if (Number(s) <= 0) return { ok: false, error: 'El precio rebajado debe ser mayor que 0.' };
  const reg = Number(norm(regular));
  if (reg > 0 && Number(s) >= reg) return { ok: false, error: 'El precio rebajado debe ser menor al normal.' };
  return { ok: true, error: null };
}

function positiveNumber(value) {
  const s = norm(value);
  if (!s) return false;
  const n = Number(s);
  return Number.isFinite(n) && n > 0;
}

function validateWeight(value) {
  if (!positiveNumber(value)) return { ok: false, error: 'Pon el peso real en kg (no 0): las transportadoras cotizan con eso.' };
  return { ok: true, error: null };
}

function validateDimensions(dims) {
  const d = dims || {};
  if (!positiveNumber(d.length) || !positiveNumber(d.width) || !positiveNumber(d.height)) {
    return { ok: false, error: 'Pon largo, ancho y alto reales del paquete (ninguno en 0).' };
  }
  return { ok: true, error: null };
}

function validateGtin(value) {
  const s = norm(value);
  if (!s) return { ok: true, error: null }; // opcional
  if (!/^\d+$/.test(s)) return { ok: false, error: 'El GTIN/EAN son solo dígitos.' };
  // Tanda 4b: los largos reales de un GTIN (EAN-8, UPC-12, EAN-13, GTIN-14).
  if (![8, 12, 13, 14].includes(s.length)) {
    return { ok: false, error: `El GTIN/EAN tiene 8, 12, 13 o 14 dígitos (vas en ${s.length}).` };
  }
  return { ok: true, error: null };
}

// CJS a propósito (tanda 6): lo consume fichaEstado.js, que corre también en
// el backend — mismo patrón que groupOrdersByProduct.
module.exports = {
  isAllCaps, validateName, validateShortDescription, validateSku,
  validatePrice, validateSalePrice, validateWeight, validateDimensions, validateGtin,
};
